export const OperacionADLFields = {
    CodOperacionADL: 'id',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    UnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    SectorComercial: 'descSectorComercial',
    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    FechaAprobacion: 'fechaAprobacion',
    
    RazonSocial: 'razonSocial',
    CodClienteTipo: 'codClienteTipo',
    DescClienteTipo: 'descClienteTipo',
    NroCuenta: 'nroCuenta',
    CodLegislacionTipo: 'codLegislacionTipo',
    DescLegislacionTipo: 'descLegislacionTipo',
    EntidadPuenteAcreedora: 'entidadPuenteAcreedora',

    Moneda: 'moneda',
    Monto: 'monto',
    ComisionEstructuracion: 'comisionEstructuracion',
    TasaInteres: 'tasaInteres',
    Plazo: 'plazo',
    TipoAmortizacionCapital: 'tipoAmortizacionCapital',
    FrecuenciaPagoInteres: 'frecuenciaPagoInteres',

    Garantias: 'garantias',
    DetalleGarantias: 'detalleGarantias',
    DetalleAforo: 'detalleAforo',
    Precancelable: 'precancelable',
    CondicionesPrecancelacion: 'condicionesPrecancelacion',

    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    FechaUltMod: 'fechaUltMod',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',

    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',

    CodVirtualCliente: 'codVirtualCliente',
    CodVirtualLegislacion: 'codVirtualLegislacion',
} as const;
